// extracted by mini-css-extract-plugin
module.exports = {"card-display":"CardDisplay_card-display__nfuP+","card-body":"CardDisplay_card-body__0CkS2"};